import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useContext, useEffect, useMemo, useState } from "react";
import { useEmbarqueDependencias } from "../../contexts/EmbarqueDependenciasContext.tsx";
import RequestControllerRedux from "../../contexts/RequestController.js";
import TabelaRedux from "../../contexts/Tabela.js";
import CustomButtonV2 from "../CustomButtonV2/CustomButtonV2.js";
import ModalCadastro from "../ModalCadastro/ModalCadastro.tsx";
import "../ModalLancarEmbalagem/ModalLancarEmbalagem.css";
import NewIcon from "../NewIcon/NewIcon.js";
import SelectEmbarqueV2 from "../SelectEmbarqueV2/SelectEmbarqueV2.js";

export interface SimpleDialogProps {
	titulo: string;
	tituloBotao: string;
	tituloConfirmar: string;
	texto: string;
	dataAlteracao: string;
	open: boolean;
	onClose: () => void;
	onClick: () => void;
	setEmbalagem: (e) => void;
}

function ModalLancarEmbalagem(props: SimpleDialogProps) {
	const { setDadosRequestControllerRedux } = useContext(RequestControllerRedux);

	const { embalagem } = useEmbarqueDependencias();

	const { tabelaRedux } = useContext(TabelaRedux);

	const { onClose, open, onClick } = props;

	const [valuesSelect, setValuesSelect] = useState<any>([]);

	const handleClose = () => {
		onClose();
		if (embalagemSelecionado) {
			setValuesSelect((current) => ({
				...current,
				embalagem: {
					value: embalagemSelecionado.nome,
					label: embalagemSelecionado.nome,
					id: embalagemSelecionado.idEmbalagem,
				},
			}));
			props.setEmbalagem(embalagemSelecionado.idEmbalagem);
		}
	};

	const handleClick = () => {
		onClick();
	};

	const clearEmbalagem = () => {
		setValuesSelect((current) => ({ ...current, embalagem: "" }));
	};

	const [idAtual, setIdAtual] = useState(0);

	const [disable, setDisable] = useState(false);

	const [openCadastroEmbalagem, setOpenCadastroEmbalagem] = useState(false);

	const embalagemSelecionado = useMemo(() => {
		return embalagem.find(
			(option) => option.nome === tabelaRedux?.row?.embalagem
		);
	}, [embalagem, tabelaRedux?.row?.embalagem]);

	useEffect(() => {
		if (embalagemSelecionado) {
			setValuesSelect((current) => ({
				...current,
				embalagem: {
					value: embalagemSelecionado.nome,
					label: embalagemSelecionado.nome,
					id: embalagemSelecionado.idEmbalagem,
				},
			}));
			props.setEmbalagem(embalagemSelecionado.idEmbalagem);
		}
	}, [embalagemSelecionado]);

	const handleCloseCadastroEmbalagem = () => {
		if (idAtual) {
			setOpenCadastroEmbalagem(false);
			setDadosRequestControllerRedux("Close Embalagem ");
		} else {
			setDadosRequestControllerRedux("Close Embalagem ");
			setOpenCadastroEmbalagem(false);
		}
	};

	return (
		<div>
			<Dialog open={open} onClose={handleClose}>
				<div className="div-modal-usuario">
					<DialogTitle id="alert-dialog-title">{props.titulo}</DialogTitle>
					<DialogContent className="content-veiculo">
						<div className="usuario-data-row">
							<div className="coluna-modalmotivo">
								<div>
									<p className="input-label-emb">Embalagem:</p>
									<SelectEmbarqueV2
										classeCss={225}
										onChange={(e) => {
											setValuesSelect((current) => ({
												...current,
												embalagem: e,
											}));
											props.setEmbalagem(e.id);
										}}
										clearSelection={clearEmbalagem}
										onInfoIconClick={setIdAtual}
										id="idEmbalagem"
										pequeno={true}
										value={valuesSelect.embalagem}
										titulo="Embalagem"
										dadosSelect={embalagem}
										referenciaId="nome"
										referenciaItem="nome"
									/>
								</div>
								<NewIcon
									onClick={(e) => {
										setOpenCadastroEmbalagem(true);
										setIdAtual(0);
										setDisable(false);
									}}
								/>
							</div>
						</div>
					</DialogContent>
					<DialogActions>
						<CustomButtonV2
							classCss="custom-button-cadastrar"
							classText="button-texto-cadastrar"
							titulo="OK"
							cor="#0946B8"
							onClick={handleClick}
						/>
						<CustomButtonV2
							classCss="custom-button-cancelar"
							classText="button-texto-cancelar"
							titulo="Cancelar"
							cor="#0946B8"
							onClick={handleClose}
						/>
					</DialogActions>
				</div>
			</Dialog>
			<div>
				<ModalCadastro
					titulo="Cadastro"
					tituloConfirmar="OK"
					cadastroEmbalagem="sim"
					open={openCadastroEmbalagem}
					idAtual={idAtual}
					desabilitar={disable}
					onClose={handleCloseCadastroEmbalagem}
				/>
			</div>
		</div>
	);
}

export default ModalLancarEmbalagem;
